<template>
  <div class="wrapper main" ref="wrapper">
    <main-header
      :class="[{ showNavbar: !showNavbar }, { isPageOff: isPageOff }]"
      @hamActive="hamActives"
      :isOn="isOn"
      :showNavbar="showNavbar"
      :isPageOff="isPageOff"
      ref="Header"
    ></main-header>
    <div class="container" ref="container">
      <div class="page-item-wrap" ref="page-item-wrap">
        <router-view
          @mouseWheelHandle="onScroll"
          :lastScrollPosition="lastScrollPosition"
          :showNavbar="showNavbar"
          ref="route"
        ></router-view>
      </div>
      <main-footer ref="main-footer"></main-footer>
    </div>
    <transition name="slide-fade" mode="out-in">
      <fullNav
        v-if="isOn"
        :isOn="isOn"
        @routeActive="hamActives"
        style="z-index: 9998"
      ></fullNav>
    </transition>
  </div>
</template>

<script>
import mainHeader from 'Components/layout/header'
import fullNav from 'Components/layout/content/fullNav'
import mainFooter from 'Components/layout/mainFooter'
export default {
  data() {
    return {
      isOn: false,
      showNavbar: true,
      isPageOff: false,
      lastScrollPosition: 0,
      scrollValue: 0,
    }
  },
  components: {
    mainHeader,
    fullNav,
    mainFooter,
  },
  watch: {
    lastScrollPosition: {
      immediate: true,
      handler() {
        // console.log(this.$refs.route.$refs.section1.scrollHeight)
        if (window.pageYOffset < 700 && this.$route.name == 'main') {
          this.isPageOff = false
        } else if (this.$route.name !== 'main' && window.pageYOffset < 300) {
          this.isPageOff = false
        } else {
          this.isPageOff = true
        }
      },
    },
  },
  computed: {},
  methods: {
    hamActives() {
      if (this.isOn === true) {
        this.$refs.Header.isActive = false
      } else {
        this.$refs.Header.isActive = true
      }
      // console.log()
      this.isOn = !this.isOn
    },
    onScroll() {
      // console.log(window.pageYOffset)
      const OFFSET = 60
      if (window.pageYOffset < 0) {
        this.showNavbar = false

        // console.log(' this.showNavbar', this.showNavbar)
        return
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
        // console.log(' this.showNavbar', this.showNavbar)
        return
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition
      this.lastScrollPosition = window.pageYOffset
    },
  },
  async created() {},

  mounted() {
    this.lastScrollPosition = window.pageYOffset
    window.addEventListener('scroll', this.onScroll)
    const viewportMeta = document.createElement('meta')
    viewportMeta.name = 'viewport'
    viewportMeta.content = 'width=device-width, initial-scale=1'
    document.head.appendChild(viewportMeta)
    let vh = window.innerHeight * 0.01

    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>

<style>
/* .slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.fullNav.active {
  transform: translateX(-20px);
  opacity: 1;
} */
.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.8s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
